// ************
// Recipe Single View
// Recipe Instruction Component
// Schwierigkeitsgrad 1 - only illustration images
// Schwierigkeitsgrad 2 - illustration images, description and ingredients
// Schwierigkeitsgrad 3 - no illustration images, only description and ingredients
// ************
import { RecipeType } from "@/types/baseTypes";
import { customSanitize } from "@/utils/customSanitize";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";
import RecipeIngredientTable from "../RecipeIngredientList/RecipeIngredientTable/RecipeIngredientTable";
import styles from "./RecipeInstruction.module.scss";
import Image from "next/image";
import InlineMediaInfo from "@/components/MediaInfo/InlineMediaInfo";

interface RecipeInstructionProps {
  recipeDetails: RecipeType;
}

function RecipeInstruction({ recipeDetails }: RecipeInstructionProps) {
  const { getLabel } = useGlobalContext();
  return (
    <section className={`${styles.instruction}`}>
      <h2 className="has-text-centered">{getLabel("step_by_step")}</h2>
      {recipeDetails.steps_portion_big.length && (
        <ul>
          {recipeDetails.steps_portion_big.map((step, index) => {
            const {
              step_beschreibung,
              step_illustration,
              step_illustration_width,
              step_illustration_height,
              // step_kategorie,
              step_titel,
              step_zutaten,
            } = step;
            return (
              <li
                className={`${styles["step-wrapper"]}`}
                key={`step-${index}`}
                data-has-border-bottom={
                  recipeDetails.schwierigkeitsgrad === 3 ? "true" : "false"
                }
              >
                {recipeDetails.schwierigkeitsgrad === 3 && (
                  <>
                    <h3>
                      {index + 1}. {getLabel("step")}
                    </h3>
                    {step_titel && <p className="h3">{step_titel}</p>}
                  </>
                )}
                {recipeDetails.schwierigkeitsgrad < 3 && step_illustration && (
                  <Image
                    src={step_illustration}
                    height={step_illustration_height}
                    width={step_illustration_width}
                    sizes="(max-width: 1023px) 95vw, 45vw"
                    alt={getLabel("aria_label_illustration_image").replace(
                      "$$title",
                      step_titel ? step_titel : (index + 1).toString(),
                    )}
                    data-has-margin-bottom={
                      recipeDetails.schwierigkeitsgrad === 2 ? "true" : "false"
                    }
                  />
                )}
                {recipeDetails.schwierigkeitsgrad === 1 && (
                  <InlineMediaInfo
                    step_zutaten={step_zutaten}
                    description={step.step_beschreibung}
                    focusOnOpen
                    className={styles["inline-media-info"]}
                  />
                )}
                {recipeDetails.schwierigkeitsgrad > 1 && (
                  <>
                    {step_zutaten.length && (
                      <RecipeIngredientTable ingredients={step_zutaten} />
                    )}
                    <div
                      className="mt-4"
                      dangerouslySetInnerHTML={{
                        __html: customSanitize(step_beschreibung),
                      }}
                    ></div>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

export default RecipeInstruction;
